import React, { useState } from 'react'
import { blue, green, purple9, redPrimary } from '../../../color'
import {
  EyeOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from '@ant-design/icons'
import fileStore from '../../../stores/fileStore'
import FileViewPopup from '../../FileViewPopup'
import { Tooltip } from 'antd'
import styled from 'styled-components'
import { DownloadMinimalisticOutlineIcon } from '../../AppIcon'
import utils from '../../../utils'

const FileItemWrapper = styled.div`
  word-break: break-word;
  white-space: pre-line;
  .view-icon {
    color: ${green};
    padding: 3px 8px;
    height: 18px;
    transform: translateY(1px);
    border-radius: 4px;
    margin-left: 4px;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`
const FileItemV3 = props => {
  const { file_id, file_name } = props || {}

  const [isVisibleFileViewPopup, setIsVisibleFileViewPopup] = useState(false)

  const fileOnlyName = utils.removeExtensionFile(file_name)
  const fileExtension = utils.getExtensionFile(file_name)

  const isFileTruc = window.location.pathname.includes('messages')
  const isFileVIMCToTruc = window.location.pathname.includes(
    'connected-document'
  )

  let iconFile = <FileTextOutlined style={{ fontSize: 24 }} />
  if (fileExtension === 'pdf') {
    iconFile = <FilePdfOutlined style={{ color: redPrimary, fontSize: 24 }} />
  }
  if (fileExtension === 'doc' || fileExtension === 'docx') {
    iconFile = <FileWordOutlined style={{ color: blue, fontSize: 24 }} />
  }
  if (
    [
      'jpg',
      'bmp',
      'dib',
      'jpe',
      'jfif',
      'gif',
      'tif',
      'tiff',
      'png',
      'heic',
    ].includes(fileExtension)
  ) {
    iconFile = <FileImageOutlined style={{ color: purple9, fontSize: 24 }} />
  }
  if (fileExtension === 'rar' || fileExtension === 'zip') {
    iconFile = <FileZipOutlined style={{ color: '#e67e22', fontSize: 24 }} />
  }
  if (fileExtension === 'xlsx' || fileExtension === 'xls') {
    iconFile = <FileExcelOutlined style={{ color: green, fontSize: 24 }} />
  }

  const canViewFileDetail =
    fileExtension &&
    [
      'pdf',
      'doc',
      'docx',
      'xlsx',
      'xls',
      'jpg',
      'bmp',
      'dib',
      'jpe',
      'jfif',
      'gif',
      'tif',
      'tiff',
      'png',
      'heic',
    ].includes(fileExtension)

  return (
    <div
      style={{
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        backgroundColor: '#FFF',
        padding: '12px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '8px',
        minWidth: '250px',
        flexShrink: 0,
      }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          width: '100%',
        }}>
        {iconFile}
        <Tooltip title={canViewFileDetail ? 'Xem file' : null}>
          <div
            style={{
              marginRight: 'auto',
              display: 'flex',
              cursor: canViewFileDetail ? 'pointer' : 'default',
            }}
            onClick={() => {
              if (canViewFileDetail) setIsVisibleFileViewPopup(true)
            }}>
            <span
              style={{
                maxWidth: '140px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '12px',
                fontWeight: '500',
                color: 'black',
                display: 'inline-block',
              }}>
              {fileOnlyName}
            </span>

            <span
              style={{
                fontSize: '12px',
                fontWeight: '500',
                color: 'black',
                display: 'inline-block',
              }}>
              .{fileExtension}
            </span>
          </div>
        </Tooltip>
        <Tooltip title={'Tải xuống'}>
          <DownloadMinimalisticOutlineIcon
            style={{ width: 20, height: 20, color: blue, cursor: 'pointer' }}
            onClick={() => {
              if (isFileVIMCToTruc)
                return fileStore.handleDownloadAttachmentTruc(
                  file_id,
                  file_name
                )
              if (isFileTruc)
                return fileStore.handleDownloadFileTruc(file_id, file_name)
              return fileStore.handleDownloadFile(file_id, file_name)
            }}
          />
        </Tooltip>
      </div>
      <FileViewPopup
        file={{
          file_name: file_name,
          file_id: file_id,
        }}
        isVisibleFileViewPopup={isVisibleFileViewPopup}
        handleCloseFileViewPopup={() => setIsVisibleFileViewPopup(false)}
      />
    </div>
  )
}

export default FileItemV3
